var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.634,
    height: 35,
    viewBox: "0 0 24.634 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.222,
    y1: 1,
    x2: 0.787,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88b053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50840b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4350",
    "data-name": "Group 4350",
    transform: "translate(-1597.6 -781.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(1597.6 781.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M8.75,17.991,21.775.063,21.688,0H13.1L4.389,11.988l0,0-4.361,6,0,0H8.75Z",
    transform: "translate(2.859 17.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8-2",
    "data-name": "Subtraction 8",
    d: "M13.051,0,.026,17.927l.087.063H8.7L17.412,6l0,0,4.361-6,0,0H13.051Z",
    transform: "translate(-0.026 0)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySmall);
export default __webpack_public_path__ + "static/media/pay_small.2d1d68f82d6a7aaa04cd712270afbb75.svg";
export { ForwardRef as ReactComponent };